<div
  class="badge-container"
  [ngClass]="[
    status,
    shape,
    size,
    flat ? 'flat' : '',
    outline ? 'outline-' + status : ''
  ]"
>
  <ng-content></ng-content>
</div>
